import { render, staticRenderFns } from "./EditServerNameModal.vue?vue&type=template&id=16b50611&"
import script from "./EditServerNameModal.vue?vue&type=script&lang=js&"
export * from "./EditServerNameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports